export const SELECT_AWARD = 'SELECT_AWARD';
export const SELECT_ARTICLE = 'SELECT_ARTICLE';
export const COLLAPSE_AWARDS= 'COLLAPSE_AWARDS';